import axios from 'axios';
import router from '../../router/routes';
import notify from './notify';
import store from '../store';

export default function destroyEditorData(axiosRoute) {
    store.commit('overlay/toggle', true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .post(axiosRoute)
            .then((response) => {
                notify(response.data.message, 'success');
                const base = router.currentRoute.path.split('/')[1];
                router.push('/' + base + '/index');
                resolve(true);
            })
            .catch((error) => {
                notify(error.response.data.message, 'error');
                store.commit('overlay/toggle', false, { root: true });
                reject(false);
            });
    });
}
